var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon /DSAR",
    clipPath: "url(#clip0_1718_2040)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8073 22.1666L18.849 24.2083H7.87504C7.31358 24.2083 6.83294 24.0084 6.43311 23.6086C6.03329 23.2087 5.83337 22.7281 5.83337 22.1666V5.83329C5.83337 5.27183 6.03329 4.79119 6.43311 4.39137C6.83294 3.99154 7.31358 3.79163 7.87504 3.79163H17.0625L22.1667 9.91663V22.1666C22.1667 22.5069 22.0944 22.8174 21.9498 23.0981C21.8052 23.3789 21.6052 23.6128 21.35 23.8L16.0417 18.5427C15.7525 18.7298 15.4377 18.8702 15.0974 18.9638C14.7572 19.0573 14.3914 19.1041 14 19.1041C12.8771 19.1041 11.9158 18.7043 11.1162 17.9046C10.3165 17.105 9.91671 16.1437 9.91671 15.0208C9.91671 13.8979 10.3165 12.9366 11.1162 12.1369C11.9158 11.3373 12.8771 10.9375 14 10.9375C15.123 10.9375 16.0842 11.3373 16.8839 12.1369C17.6835 12.9366 18.0834 13.8979 18.0834 15.0208C18.0834 15.4121 18.0366 15.7779 17.943 16.1182C17.8494 16.4585 17.7091 16.7732 17.5219 17.0625L20.125 19.7166V10.6312L16.0927 5.83329H7.87504V22.1666H16.8073ZM14 17.0625C14.5615 17.0625 15.0421 16.8625 15.442 16.4627C15.8418 16.0629 16.0417 15.5823 16.0417 15.0208C16.0417 14.4593 15.8418 13.9787 15.442 13.5789C15.0421 13.179 14.5615 12.9791 14 12.9791C13.4386 12.9791 12.9579 13.179 12.5581 13.5789C12.1583 13.9787 11.9584 14.4593 11.9584 15.0208C11.9584 15.5823 12.1583 16.0629 12.5581 16.4627C12.9579 16.8625 13.4386 17.0625 14 17.0625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1718_2040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsarIcon);
export default __webpack_public_path__ + "static/media/DSAR-icon.375c20283da82e2b4da2faf046e2bac6.svg";
export { ForwardRef as ReactComponent };